import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background-color: white;
  border-radius: 6px;
`;

const Card = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Card;
